import { queryKeys } from "../queryKeys";
import { getWatchlist, type Watchlist } from "../rest/account";
import useRequest, { type QueryOptions } from "./useRequest";

export const useGetWatchlist = ({
  accountID = "",
  name = "Primary Watchlist",
  options,
}: {
  accountID?: string;
  name?: string;
  options?: QueryOptions<Watchlist>;
}) => {
  const {
    data: watchlist,
    refetch,
    isFetched,
  } = useRequest(
    queryKeys.watchlists.detail(accountID || "", name || ""),
    () => getWatchlist({ accountID, name }),
    {
      ...options,
      refetchInterval: false,
    },
  );

  return { watchlist, refetch, isFetched };
};

export default useGetWatchlist;
